<script lang="ts">
    import {fade} from "svelte/transition"
    import {getOptimizedImageURL} from "../utils/getImageParams";
    import type {ImageRatio} from "../../../../dashboard/dashboard-client/src/store/productGridEditor/models";
    import {platform} from "../store/store";
    import ImageCarousel from "./ImageCarousel.svelte";

    /* Props */
    export let src: string
    export let alt: string
    export let imageSize: number
    export let productsPerPage: number
    export let imgRatio: ImageRatio
    export let vertical: boolean
    export let id: string
    export let isProductHover: boolean;
    export let onHoverCarousel: boolean;
    export let path: string

    const NO_IMAGE = `${window.location.protocol}//magento.instantsearchplus.com/images/missing.gif`

    function onError() {
        console.log("image error :(")

        imageSrc = NO_IMAGE;
    }

    /*State */
    let imageSrc = "";

    /* Reactive: image source */
    $:imageSrc = src ?? NO_IMAGE;
    // $:imageSrc = getOptimizedImageURL(src, imageSize) ?? NO_IMAGE;

    /* Reactive: image size for vertical */
    // $:imageSize = vertical ? imageSize - 60 : imageSize;

    /*Reactive: style*/
    $:style = `${vertical ? "height" : "width"}: ${imageSize}px; aspect-ratio: ${imgRatio.replace(":", "/")}; object-fit: ${imgRatio === "9:16" | imgRatio === "2:3" | imgRatio === "3:4" ? "cover" : "contain"};`

</script>

<div class="container upsell-cross-sell-image-container">
    {#if onHoverCarousel && $platform === "Shopify"}
        <ImageCarousel id={id} productHover={isProductHover} maxWidth={imageSize} imageURL={imageSrc} productURL={path}
                       style={style}/>
    {:else}
        <img class="fs-recommendation-product-image" style={style} alt={alt} src={imageSrc} on:error={onError} in:fade/>
    {/if}
</div>

<style>
    .container {
        position: relative;
    }
</style>